import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: './dashboard/dashboard.module#DashboardModule'
  },
  {
    path: 'receitas-despesas',
    loadChildren: './receitas-despesas/receitas-despesas.module#ReceitasDespesasModule'
  },
  {
    path: 'consulta-declaracao',
    loadChildren: './consulta-declaracao/consulta-declaracao.module#ConsultaDeclaracaoModule'
  },
  
  { path: '**', redirectTo: 'not-found' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' , preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
